import React from 'react';
import { CreateButton } from 'react-admin';

export const PumpsSpeedCreateButton = (props: any) => {
  return <CreateButton label="resources.pumps.speeds.fields.import" />;
};
